import { X } from "lucide-react";

export function FilterBanner({ label, onClear }) {
  if (!label) return null;
  return (
    <div data-testid="filter-banner" className="flex items-center gap-2 mb-4 text-xs">
      <span className="px-3 py-1.5 rounded-full text-white flex items-center gap-2" style={{ background: "var(--brand-dark)" }}>
        Filtro attivo: {label}
        <button onClick={onClear} data-testid="filter-clear" className="hover:opacity-70" aria-label="Rimuovi filtro">
          <X className="w-3 h-3" />
        </button>
      </span>
    </div>
  );
}
